import React, { useState,useRef,useEffect } from 'react';
import { resizeFile } from '../../../assets/js/imageReSizer';

export default function EditMessProfile({editMessDetails,setEditMess}){
    const [messDetails,setMessDetails]=useState(editMessDetails);
    const messPicRef = useRef();

    useEffect(() => {
        setMessDetails(editMessDetails);
    }, [editMessDetails]);

    const handleMessDetails = (e) =>{
        let name = e.target.name;
        let value = e.target.value;
        if (e.target.type === 'file') {
            let files = e.target.files;
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    resizeFile(files[i]).then(res =>setEditMess(pre=>(pre.map(m=>m.id===messDetails.id?{
                        ...m, pic: [...m.pic,res] }
                    :m))));
                }
            }
            
        } else {
            setEditMess(pre=>(pre.map(m=>m.id===messDetails.id?{
                ...m, [name]: value 
            }:m)));
        }
        
    }

    const deletePic = (d) => {
        setEditMess(pre=>(pre.map(m=>m.id===messDetails.id?{
            ...m, pic: m.pic.filter(p=>p!==d)
        }:m)));
    }

    const uploadMessPic = () => {
        document.getElementById("mess_pic").click();
    }

    const deleteMess = (val) => {
        setEditMess(pre=>(pre.filter(m=>m.id !== val)));
    }

    return(
        <div className="row gy-3 pb-3" style={{background:"rgb(245 241 241)"}}>
            <b>Id: {messDetails.id}
            <button className="btn btn-sm btn-danger float-end" onClick={() => deleteMess(messDetails.id)}>cancel</button></b>
        <div className="col-12 col-sm-12 ">
            <input type="file" id="mess_pic" name="mess_pic" className="form-control" style={{ display: "none" }}
              multiple={true}  ref={messPicRef} onChange={handleMessDetails} />
            <button className="btn btn-secondary" onClick={uploadMessPic}><i className='bx bxs-camera'></i> Add Picture</button>
        </div>
        <div className="col-12 col-sm-12">
        <div className="row ">
            {messDetails.pic && messDetails.pic.length > 0 && messDetails.pic.map((p, index) => <div key={index} className="col-6 col-sm-4">
            <img src={p} alt="mess pic" className="img-fluid"/>
            <i className="bx bx-x-circle bx-flip-horizontal" style={{color: '#d01f1f',position:'absolute',cursor:'pointer'}} 
            onClick={()=>deletePic(p)}/>

        </div>)}
            </div>
        
        </div>
        <div className="col-6 col-sm-6">
            <select className="form-select" name="type" value={messDetails.type} onChange={handleMessDetails}>
                <option value="">Select type</option>
                <option value="Mess">Mess</option>
                <option value="Flat">Flat</option>
            </select>
        </div>
        <div className="col-6 col-sm-6">
            <select className="form-select" name="for" value={messDetails.for} onChange={handleMessDetails}>
                <option value="">Select for</option>
                <option value="All">For all</option>
                <option value="Girls">For girls</option>
                <option value="Boys">For boys</option>
                <option value="Married">For married</option>
            </select>
        </div>

        <div className="col-12 col-sm-12">
            <input type="text" className="form-control" name="area" placeholder="Area" value={messDetails.area} onChange={handleMessDetails} />
        </div>
        <div className="col-6 col-sm-6">
            <input type="text" className="form-control" name="district" placeholder="District" value={messDetails.district} onChange={handleMessDetails} />
        </div>
        <div className="col-6 col-sm-6">
            <input type="text" className="form-control" name="state" placeholder="State" value={messDetails.state} onChange={handleMessDetails} />
        </div>
        <div className="col-6 col-sm-6">
            <input type="text" className="form-control" name="pin" placeholder="Pin" value={messDetails.pin} onChange={handleMessDetails} />
        </div>
        <div className="col-6 col-sm-6">
            <input type="text" className="form-control" name="rent" placeholder="Rent" value={messDetails.rent} onChange={handleMessDetails} />
        </div>
        <div className="col-12 col-sm-12">
            <textarea className="form-control" name="information" placeholder="Information" value={messDetails.information} onChange={handleMessDetails} />
        </div>
    </div>
    );
}